import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Link } from "react-router-dom";

import Popover from "components/library/Popover";
import styles from "./RevisionsListPopover.css";

export default class RevisionsListPopover extends React.Component {
  constructor(props) {
    super(props);
    this.calculateOffset = this._calculateOffset.bind(this);
  }

  _calculateOffset() {
    const popoverHeight = this.props.disabled ? 85 : 170;
    const marginOffset = 10;
    if (!this.props.element) {
      return;
    }

    const boundingClientRect = this.props.element.getBoundingClientRect();
    return {
      top: boundingClientRect.top - popoverHeight / 2 - marginOffset,
      left: boundingClientRect.left + 7,
    };
  }

  render() {
    const position = this.calculateOffset();

    return (
      <Popover
        isOpened={this.props.isActive}
        position={position}
        className={styles.root}
        closeModal={this.props.closeModal}
      >
        <Link
          to={`${this.props.getBaseUrl()}preview/${this.props.revisionId}`}
          className={classNames(styles.menuItem)}
          target="_blank"
          type="tertiary"
        >
          Preview
        </Link>
        {this.props.disabled ? null : (
          <Link
            to={`${this.props.getBaseUrl()}revert/${this.props.revisionId}`}
            className={classNames(styles.menuItem)}
            type="tertiary"
          >
            Revert to this version
          </Link>
        )}
      </Popover>
    );
  }
}

RevisionsListPopover.propTypes = {
  isActive: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  getBaseUrl: PropTypes.func.isRequired,
  revisionId: PropTypes.number.isRequired,
  element: PropTypes.instanceOf(Element),
};
